export default __webpack_public_path__ + "static/media/gallery08.58193514.webp";